import { render, staticRenderFns } from "./ProductReturnForm.vue?vue&type=template&id=15e5d939&"
import script from "./ProductReturnForm.vue?vue&type=script&lang=js&"
export * from "./ProductReturnForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports